<template>
    <div>
        <st-loading v-if="!detail" :visible="loading" />
        <div v-else>
            <school-detail-styled>
                <school-icon class="school-thum" :path="detail.thumbUrl" :size="10" :marginRight="0" />

                <st-divider class="text-info" :between="2.4">
                    <div class="school-top-title">{{ detail.name }}</div>
                    <div class="school-top-address">{{ detail.address }}</div>
                    <div class="school-top-contact">{{ detail.contact }}</div>
                </st-divider>

                <st-button
                    :width="32.5"
                    :color="detail.isFollowed === 0 ? 'primary_reverse' : 'primary'"
                    @click="$emit('follow', detail.isFollowed)"
                >
                    {{ detail.isFollowed === 0 ? "구독하기" : "구독중" }}
                </st-button>
            </school-detail-styled>

            <!-- <transition name="banner-slider">
                <school-banner-styled v-if="banner">
                    <div class="school-thum">
                        <school-icon :path="detail.thumbUrl" :size="4.8" :marginRight="0" />
                    </div>
                    <div class="school-banner-info">
                        <div class="school-top-title">{{ detail.name }}</div>
                        <div class="school-top-address">{{ detail.address }}</div>
                        <div class="school-top-contact">{{ detail.contact }}</div>
                    </div>
                    <st-button
                        class="subscribe-button"
                        :width="14"
                        :color="detail.isFollowed === 0 ? 'primary_reverse' : 'primary'"
                        @click="$emit('follow', detail.isFollowed)"
                    >
                        {{ detail.isFollowed === 0 ? "구독하기" : "구독중" }}
                    </st-button>
                </school-banner-styled>
            </transition> -->
        </div>
    </div>
</template>
<script>
import styled from "vue-styled-components";
import SchoolIcon from "../../../components/SchoolIcon";

// const SchoolBannerStyled = styled("div")`
//     position: fixed;
//     z-index: 8;
//     display: flex;
//     align-items: center;
//     top: 8.4rem;
//     margin-left: 1rem;
//     width: calc(724px - 20px);
//     padding: 2.4rem 3.2rem;
//     border-radius: 5px;
//     background-color: #ffffff;
//     box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.07);
//     border: 1px solid ${props => props.theme.color.line};

//     .school-thum {
//         margin-right: 1rem;
//         width: 80px;
//     }

//     .subscribe-button {
//         width: 14rem;
//     }

//     .text-info {
//         line-height: 1.6;
//     }

//     .school-banner-info {
//         flex: 1;
//         margin-right: 1rem;
//     }

//     .school-top {
//         &-title {
//             font-size: 1.8rem;
//         }

//         &-address,
//         &-contact {
//             color: ${props => props.theme.color.disabled};
//             font-size: 1.45rem;
//         }
//     }
// `;

const SchoolDetailStyled = styled("div")`
    width: 100%;
    border-radius: 5px;
    background-color: #ffffff;
    padding: 3.2rem 0;
    text-align: center;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.07);
    margin-bottom: 2.4rem;

    .school-thum {
        margin: 0 auto 2.4rem auto;
    }

    .text-info {
        line-height: 1.6;
    }

    .school-top {
        &-title {
            font-size: 2.2rem;
        }

        &-address,
        &-contact {
            color: ${props => props.theme.color.disabled};
            font-size: 1.45rem;
        }
    }
`;

export default {
    name: "SchoolDetail",
    props: {
        banner: Boolean,
        loading: Boolean,
        detail: Object
    },
    methods: {},
    components: {
        SchoolDetailStyled,
        SchoolIcon
        //    SchoolBannerStyled
    }
};
</script>
